module.exports = __webpack_public_path__ + "static/img/02.cf66d35.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/znhy/02.jpg
// module id = wWO8
// module chunks = 1